export const trackingEvents = {
  DELETE_NETWORK: {
    CLICKED: 'employer_network_detail.delete_network_btn.clicked',
  },
}
